module.exports = __webpack_public_path__ + "img/product_2.eaba1701.png";